module.exports = __webpack_public_path__ + "img/residenzeseicento.faeebc44.jpg";